import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
  Col,
  MenuItem,
  Nav,
  NavDropdown,
  Row,
  Tab
} from 'react-bootstrap'
import Iframe from './Iframe';
import Config from '../config';
import CompanyTable from './companies/companytable'
import Loadable from 'react-loading-overlay'

@observer(['companies', 'companystates', 'globals'])
export default class AssetManager extends Component {
  constructor(props) {
    super(props);

    this.state = {
      compid: props.params.compid ? props.params.compid : null
    };
  }

  componentWillReceiveProps(props) {
    if (props.params.compid) {
      this.setState({
        compid: props.params.compid
      });
    }
  }

  componentDidMount() {
    if (this.props.params.compid) {
      this.setState({
        compid: this.props.params.compid
      });
    }
  }

  render() {
    return (
      <div className="right_col" role="main" style={{ height: 'inherit', backgroundColor: '#e7e7ea' }}>
        <Iframe
          url={this.state.compid
            ? 'https://am.gpsleaders.com/customer/'+this.state.compid
            : 'https://am.gpsleaders.com/quicklogin/'+Config.assman_token
          }
          width="100%"
          height={(window.innerHeight - 125) +'px'}
          overflow="scroll"
          position="relative"
          border="0"
          frameBorder="0"
          style={{border: '0px'}}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/assetmanager.js